/**
 * Тумблеры рубежей для карт со своей сборкой — «Буи», «Скаут», «Спутники»,
 * карта молчания судов. Один компонент на все: подпись, образец линии и
 * оговорки источника обязаны выглядеть одинаково везде, где стоит рубеж.
 *
 * Подписей источников и оговорок здесь нет (решение владельца 20.10.2026:
 * лишний текст в панели). Строка запретных районов показывается, ТОЛЬКО
 * когда слой что-то нарисовал.
 */
import { useT } from '../i18n'
import { banColor } from './bans'
import { districtColor } from './districts'
import { eezStyle } from './eez'
import type { BoundaryMeta, BoundaryToggles as Toggles } from './useBoundaryOverlays'

interface Props {
  on: Toggles
  onToggle: (key: keyof Toggles) => void
  meta: BoundaryMeta
}

function Swatch({ color, dashed }: { color: string; dashed?: boolean }) {
  return (
    <span
      aria-hidden
      className={`h-0 w-4 shrink-0 border-t-2 ${dashed ? 'border-dashed' : ''}`}
      style={{ borderColor: color }}
    />
  )
}

export function BoundaryToggles({ on, onToggle, meta }: Props) {
  const t = useT()
  return (
    <div className="space-y-1">
      <label className="flex items-center gap-2 text-mist">
        <input type="checkbox" checked={on.eez} onChange={() => onToggle('eez')} />
        <Swatch color={eezStyle('Treaty').color} />
        <span>{t('layers.eez')}</span>
      </label>
      <label className="flex items-center gap-2 text-mist">
        <input type="checkbox" checked={on.districts} onChange={() => onToggle('districts')} />
        <Swatch color={districtColor()} dashed />
        <span>{t('layers.fishing_districts')}</span>
      </label>
      {on.districts && meta.bans.disclaimerKey && (
        <div className="flex items-center gap-1.5 pl-6 text-[10px] leading-tight text-faint">
          <Swatch color={banColor()} />
          <span>{t('layers.fishing_bans')}</span>
        </div>
      )}
    </div>
  )
}
